import './css/App.css';
import React from 'react';
import { AuthProvider } from 'react-oidc-context';
import PageComponents from './components/PageComponents';

export default function App() {
  let redirect = "https://support.finpro.principal.com/firm-contact/index.html";
  if (window.location.host.includes("staging")) {
    redirect = "https://support.finpro.staging.principal.com/firm-contact/index.html";
  } else if (window.location.host.includes("local")) {
    redirect = "http://localhost:3000/firm-contact/";
  } else if (window.location.host.includes("dev")) {
    redirect = "https://support.finpro.dev.principal.com/firm-contact/index.html";
  }

const OPENID_CONFIGURATION={
    authority: 'https://login.microsoftonline.com/3bea478c-1684-4a8c-8e85-045ec54ba430/v2.0',
    client_id: '27988350-cd16-478b-9658-91b3788d091f',
    scope: 'api://firm-contact/user openid profile offline_access',
    redirect_uri: redirect,    
    silent_redirect_uri: redirect,
    automaticSilentRenew:true,
    response_type: "code",
    loadUserInfo: false,
    revokeTokensOnSignout: true,
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: true
}
const onSigninCallback = () => {
  window.history.replaceState({}, document.title, '/firm-contact/');
};
  return (
    <AuthProvider {...OPENID_CONFIGURATION} onSigninCallback={onSigninCallback}>
      <div className="App">
        <PageComponents/>
      </div>
    </AuthProvider>
  );

}
